/**
 * @file: 极速咨询 request
 */
import {
  ICreateQuickConsultReqBody,
  ITriageResultRes,
  IDepartment,
  TriageListStatus,
  ITriageListResult,
  ITriageDetail
} from '@/schemas/quick-consult';
import { IDoctorInfo } from '@/schemas/doctor';
import { checkResponse } from '@/utils/helpers';
import serviceFormat from '@utils/services-format';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  createQuickConsult: {
    url: '/health/api/v1/consult/createTriage',
    method: 'POST'
  },
  getTriageResult: {
    url: '/health/api/v1/consult/triageResult',
    method: 'GET'
  },
  getDepartmentList: {
    url: '/health/api/v1/consult/departmentList',
    method: 'GET'
  },
  getTriageDoctorList: {
    url: '/health/api/v1/consult/queryTriageDoctorList',
    method: 'GET'
  },
  triageList: {
    url: '/health/api/v1/consult/triageList',
    method: 'GET'
  },
  triageDetail: {
    url: '/health/api/v1/consult/triageDetail',
    method: 'GET'
  },
  updateDepartment: {
    url: '/health/api/v1/consult/updateDepartment',
    method: 'POST'
  },
  skinAssessment: {
    url: '/health/api/v1/photograph/assessment',
    method: 'POST'
  }
};

const user = {
  async createQuickConsult(body: ICreateQuickConsultReqBody) {
    try {
      const response: Response<number> = await request(
        api.createQuickConsult,
        undefined,
        body
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getTriageResult(triageId: number) {
    try {
      const response: Response<ITriageResultRes | null> = await request(
        api.getTriageResult,
        { triageId }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDepartmentList() {
    try {
      const response: Response<IDepartment[] | null> = await request(
        api.getDepartmentList
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getTriageDoctorList(departmentId: number) {
    try {
      const response: Response<
        IDoctorInfo[] | null
      > = await request(api.getTriageDoctorList, { departmentId });
      const { result } = response;
      return result?.map((item) =>
        serviceFormat.addServiceTypeMapForDoctor(item)
      );
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getTriageList({
    pageNum = 1,
    pageSize = 5,
    status = TriageListStatus.STAY_TRIAGE,
    triageType,
    order
  }: {
    pageNum?: number;
    pageSize?: number;
    status: number;
    triageType?: number;
    order?: number;
  }) {
    try {
      const response: Response<ITriageListResult> = await request(
        api.triageList,
        {
          pageNum,
          pageSize,
          status,
          triageType,
          order
        }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getTriageDetail(triageId) {
    try {
      const response: Response<ITriageDetail> = await request(
        api.triageDetail,
        { triageId }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async updateDepartment({ id, departmentId }) {
    try {
      const response: Response = await request(
        api.updateDepartment,
        undefined,
        { id, departmentId }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async skinAssessment(params: {
    id: number;
    departmentId?: number;
    status: number;
    triageResultInfo?: {
      diseaseName: string;
      proposal: string;
    };
  }) {
    try {
      const response: Response = await request(
        api.skinAssessment,
        undefined,
        params
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default user;
